
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Route } from 'lucide-react';
import TrailBuilder from './thematic-trails/TrailBuilder';
import TrailsList from './thematic-trails/TrailsList';

const ThematicTrailsManager: React.FC = () => {
  const [activeTab, setActiveTab] = useState('create');

  const handleTrailCreated = () => {
    // Refresh the trails list by switching to the manage tab
    setActiveTab('manage');
  };

  const handleEditTrail = (trailId: string) => {
    // TODO: Implement edit functionality
    console.log('Edit trail:', trailId);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Route className="h-6 w-6" />
        <h2 className="text-2xl font-bold">Thematic Trails</h2>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="create">Create Trail</TabsTrigger>
          <TabsTrigger value="manage">Manage Trails</TabsTrigger>
        </TabsList>

        <TabsContent value="create">
          <TrailBuilder onTrailCreated={handleTrailCreated} />
        </TabsContent>

        <TabsContent value="manage">
          <TrailsList onEditTrail={handleEditTrail} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ThematicTrailsManager;
